import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import catalog from '@/components/catalog'
import chapterOne from '@/components/chapterOne'
import chapterTow from '@/components/chapterTow'
import chapterThree from '@/components/chapterThree'
import chapterFour from '@/components/chapterFour'
import chapterFive from '@/components/chapterFive'
import chapterSix from '@/components/chapterSix'
import chapterSeven from '@/components/chapterSeven'
import chapterEight from '@/components/chapterEight'
import chapterNine from '@/components/chapterNine'
import lessonTen from '@/components/lessonTen'
import lessonEleven from '@/components/lessonEleven'
import lessonTwelve from '@/components/lessonTwelve'
import lessonThirteen from '@/components/lessonThirteen'
import lessonFourteen from '@/components/lessonFourteen'
import lessonFifteen from '@/components/lessonFifteen'
import lessonSixteen from '@/components/lessonSixteen'
import lessonSeventeen from '@/components/lessonSeventeen'
import lessonEighteen from '@/components/lessonEighteen'
import referenceAnswer from '@/components/referenceAnswer'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      // name: 'HelloWorld',
      // component: HelloWorld
      name: 'catalog',
      component: catalog
    },{
      path: '/chapterOne',
      // name: 'HelloWorld',
      // component: HelloWorld
      name: 'chapterOne',
      component: chapterOne
    },{
      path: '/chapterTow',
      name: 'chapterTow',
      component: chapterTow
    },{
      path: '/chapterThree',
      name: 'chapterThree',
      component: chapterThree
    },
    {
      path: '/chapterFour',
      name: 'chapterFour',
      component: chapterFour
    },
    {
      path: '/chapterFive',
      name: 'chapterFive',
      component: chapterFive
    },{
      path: '/chapterSix',
      name: 'chapterSix',
      component: chapterSix
    },{
      path: '/chapterSeven',
      name: 'chapterSeven',
      component: chapterSeven
    },{
      path: '/chapterEight',
      name: 'chapterEight',
      component: chapterEight
    },{
      path: '/chapterNine',
      name: 'chapterNine',
      component: chapterNine
    },{
      path: '/lessonTen',
      name: 'lessonTen',
      component: lessonTen
    },{
      path: '/lessonEleven',
      name: 'lessonEleven',
      component: lessonEleven
    },{
      path: '/lessonTwelve',
      name: 'lessonTwelve',
      component: lessonTwelve
    },{
      path: '/lessonThirteen',
      name: 'lessonThirteen',
      component: lessonThirteen
    },{
      path: '/lessonFourteen',
      name: 'lessonFourteen',
      component: lessonFourteen
    },{
      path: '/lessonFifteen',
      name: 'lessonFifteen',
      component: lessonFifteen
    },{
      path: '/lessonSixteen',
      name: 'lessonSixteen',
      component: lessonSixteen
    },{
      path: '/lessonSeventeen',
      name: 'lessonSeventeen',
      component: lessonSeventeen
    },{
      path: '/lessonEighteen',
      name: 'lessonEighteen',
      component: lessonEighteen
    },{
      path: '/referenceAnswer',
      name: 'referenceAnswer',
      component: referenceAnswer
    },
    
    
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
});






















// WEBPACK FOOTER //
// ./src/router/index.js